import { render, staticRenderFns } from "./ConfirmAllocationDialog.vue?vue&type=template&id=d8b2907e&scoped=true"
import script from "./ConfirmAllocationDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmAllocationDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfirmAllocationDialog.vue?vue&type=style&index=0&id=d8b2907e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b2907e",
  null
  
)

export default component.exports